import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { FaClipboardList, FaReceipt, FaWarehouse } from 'react-icons/fa';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../components_shared/PortalDashboard';

export default function StoreDashboardPage(){
  const [stats,setStats]=useState(null);

  useEffect(()=>{(async()=>{
    try{
      const res=await api.get('/api/v1/inventory/reports/store/summary');
      setStats(res.data);
    }catch{ setStats({totalReceipts:0,pendingIssues:0,receiptsToday:0}); }
  })();},[]);

  const safeStats=stats||{totalReceipts:0,pendingIssues:0,receiptsToday:0};

  const cards=[
    {icon:<FaWarehouse/>,label:'Total Receipts',value:safeStats.totalReceipts,desc:'Warehouse receipts logged',className:'eduss-dashboard-card-blue'},
    {icon:<FaClipboardList/>,label:'Pending Issues',value:safeStats.pendingIssues,desc:'Issues waiting action',className:'eduss-dashboard-card-yellow'},
    {icon:<FaReceipt/>,label:'Issued Today',value:safeStats.receiptsToday,desc:'Completed today',className:'eduss-dashboard-card-green'}
  ];
  const charts=[
    {title:'Store Activity',caption:'Current totals',type:'bar',data:[
      {name:'Receipts',value:Number(safeStats.totalReceipts||0)},
      {name:'Pending',value:Number(safeStats.pendingIssues||0)},
      {name:'Today',value:Number(safeStats.receiptsToday||0)}
    ],color:'#0f6fad'},
    {title:'Issue Flow',caption:'Operational view',type:'line',data:[
      {name:'Receipts',value:Number(safeStats.totalReceipts||0)},
      {name:'Pending',value:Number(safeStats.pendingIssues||0)},
      {name:'Issued',value:Number(safeStats.receiptsToday||0)}
    ],color:'#10ac84'}
  ];

  if(!stats) return <div>Loading...</div>;

  return (
    <div className="eduss-dashboard">
      <PortalHero title="Store Officer Dashboard" subtitle="Monitor warehouse receipts, pending issues, and daily stock movement." />
      <KpiGrid cards={cards} />
      <DashboardChartGrid charts={charts} />
    </div>
  );
}
